import { useEffect, useState } from 'react';
import { usePlaygroundStore } from '../storage';
import { JsonPreview } from './JsonPreview';

export const ThemeConfigPreview = () => {
  const { value: widget } = usePlaygroundStore((state) => state.widget);
  const [themeConfig, setThemeConfig] = useState<string>('');

  useEffect(() => {
    if (!widget) {
      setThemeConfig('');
      return;
    }

    const subscription = widget.subscribe('options', (options) => {
      if (!options) {
        setThemeConfig('');
        return;
      }

      const formatted = JSON.stringify(options, null, 2);
      setThemeConfig(formatted);
    });

    return () => {
      subscription?.unsubscribe?.();
    };
  }, [widget]);

  return <JsonPreview value={themeConfig} />;
};
